export const DEFAULT_POSTGRAD_CONTRACT_DURATION = 12;
